import { ReverseMoneyNumberAmount } from './ReverseMoney';

export enum ServiceTypes {
  SERVICE = 'Service',
  DISCOUNT = 'Discount',
  ADMINISTRATIVE_FEE = 'AdministrativeFee',
  ECOLOGIC_DISCOUNT = 'EcologicDiscount',
  ECOSYSTEM_DISCOUNT = 'EcosystemDiscount',
  RETURN_FEE = 'ReturnFee',
  DESTRUCTION_FEE = 'DestructionFee',
  DIRECT_PAYMENT = 'DirectPayment',
}

export interface InternalService {
  id: string;
  label: string;
  preTaxSellingPrice: ReverseMoneyNumberAmount;
  sellingPriceIncludedTax: ReverseMoneyNumberAmount;
  vatRate: number;
  type: ServiceTypes;
}
